import styled from "styled-components";

export const TabSectionStyles = styled.div<{ isActive?: boolean }>`
    background: ${({ theme, isActive }) => isActive ?
        'none' : theme.playerContentBackground};
`;